import axios from 'axios';

import actionsFactory from 'magic/actionsFactory';
import { handleError, handleSuccess } from 'magic/handlers';

const createAction = actionsFactory('organization/photoGallery/');

export const clearData = createAction('clearData');
export const setPhotoLoading = createAction('setPhotoLoading');
export const setPhotoData = createAction('setPhotoData');

export const setMainPhoto = (file, organizationId) => async (dispatch) => {
  try {
    await axios.post(`/api/rest/organization/${organizationId}/photo/add?fileStorageId=${file.id}`, null);

    dispatch(setPhotoData([{ ...file, mainPhoto: true }]));
    handleSuccess('Фото успешно установлено как основное!');
  } catch (error) {
    handleError(error);
  }
};
